export const FALLBACK_IMAGE: string = '/images/no-image.jpg';
